module.exports = __webpack_public_path__ + "static/media/pdf.9ec8f94f.svg";